import React from "react";
import Autocomplete from "react-google-autocomplete";
import { LocaleAsString } from "../../../../localeEngine";
import { Typography, Button } from "../../../utils";
import Icon from "../../../icons";
import { InputProps } from "../types";
import useInput from "../logic";
import * as styles from "../styles.module.scss";
import * as typoStyles from "../../../utils/typography/styles.module.scss";

const InputComponent = (props: InputProps) => {
  const {
    className,
    label,
    icon,
    required,
    name,
    value,
    type = "text",
    onChange,
    disablePaste,
    validation,
    onPlaceSelected,
    options,
    showIcon = true,
  } = props;
  const {
    focus,
    setFocus,
    error,
    setError,
    TriggerInputEvent,
    ValidateInput,
    HandleOnBlur,
    isFocused,
    showPassword,
    setShowPassword,
  } = useInput(props);

  const variantToCamelCase = "h400-medium".replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });

  return (
    <div className={`${styles.inputWrapper} ${className}`}>
      <div
        className={`${styles.input} ${!showIcon && styles.inputWithoutIcon} ${
          error && styles.error
        }`}
      >
        {showIcon && (
          <Icon icon={icon} size={"Small"} className={styles.icon} />
        )}
        <Typography
          component="label"
          variant={"h300-medium"}
          for={name}
          className={`${styles.label} ${isFocused && styles.focused}`}
        >
          {label}
          {required && (
            <>
              {" "}
              <span title="required" aria-label="required">
                *
              </span>
            </>
          )}
        </Typography>
        <Autocomplete
          className={`${styles.textfield} ${typoStyles[variantToCamelCase]}`}
          apiKey={"AIzaSyBHBVQKHYVK2CK85VHt1fQXQ6GAKA_gcaw"}
          onPlaceSelected={onPlaceSelected}
          options={options}
          placeholder={""}
          language={"EN"}
          {...{
            name: name,
            type: showPassword === true ? "text" : type,
            value: value,
            onChange: onChange,
            onPaste: (e) => {
              disablePaste ? e.preventDefault() : TriggerInputEvent();
            },
            onFocus: () => {
              !focus && setFocus(true);
              TriggerInputEvent();
            },
            onBlur: () => {
              HandleOnBlur(props);
              TriggerInputEvent();
            },
          }}
        />
        {type === "password" ? (
          <Button
            onClick={() => setShowPassword(!showPassword)}
            className={styles.utilityIcon}
          >
            {showPassword === true ? (
              <Icon icon="Eye" size="Small" className={styles.uIcon} />
            ) : (
              <Icon icon="EyeOff" size="Small" className={styles.uIcon} />
            )}
          </Button>
        ) : null}
      </div>
      <Typography
        component="p"
        variant="h200-medium"
        className={`${styles.errorMessage} ${error && styles.visible}`}
      >
        <LocaleAsString id={error} />
      </Typography>
    </div>
  );
};
//
export default InputComponent;
